module.exports = __webpack_public_path__ + "f99a231ed57ee113b50b1c3e9f9fcdc3.svg";